import DomainException from '~/modules/Exceptions/Domain/DomainException'
import { User } from '~/modules/Auth/Domain/User'

export default class TrophyDomainException extends DomainException {
  public static invalidMintStatusId = 'trophy_invalid_mint_status_id'
  public static notMintableId = 'trophy_not_mintable_id'
  public static userCannotMintTrophyId = 'trophy_user_cannot_mint_trophy_id'
  public static trophyIsNotInMintingProcessId = 'trophy_is_not_in_minting_process_id'
  public static trophyDoesNotBelongToUserId = 'trophy_trophy_does_not_belong_to_user'
  public static cannotAddMemoryToTrophyId = 'trophy_cannot_add_memory_to_trophy'

  public static invalidMintStatus (): TrophyDomainException {
    return new TrophyDomainException('Invalid mint status', this.invalidMintStatusId)
  }

  public static notMintable (): TrophyDomainException {
    return new TrophyDomainException('Trophy is not mintable', this.notMintableId)
  }

  public static userCannotMintTrophy (): TrophyDomainException {
    return new TrophyDomainException('User cannot mint trophy', this.userCannotMintTrophyId)
  }

  public static notInMintingProcess (): TrophyDomainException {
    return new TrophyDomainException(
      'Trophy is not in a minting process now',
      this.trophyIsNotInMintingProcessId
    )
  }

  public static doesNotBelongToUser (
    trophyId: string,
    userId: User['id']
  ): TrophyDomainException {
    return new TrophyDomainException(
      `Trophy with ID ${trophyId} does not belong to user with ID ${userId}`,
      this.trophyDoesNotBelongToUserId
    )
  }

  public static cannotAddMemory (
    trophyId: string
  ): TrophyDomainException {
    return new TrophyDomainException(
      `Cannot add a new memory to trophy with ID ${trophyId}. Max number of memories reached.`,
      this.cannotAddMemoryToTrophyId
    )
  }
}
